module.exports = __webpack_public_path__ + "img/icon-type-refund.53af6e13.png";